import { AMOUNTS } from 'constants/amounts';

export const parseCreditAmountForNumberForm = (amount?: string) => {
  const parsedAmount = Number(amount);

  return Number.isFinite(parsedAmount) && parsedAmount > 0 ? parsedAmount : AMOUNTS.defaultFormValue;
};
